import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";

import { PaymentAccordionArrowIcon } from "../../../../assets/icons/MUI/PaymentIcons";
import { PaymentOverviewAccordionProps } from "../../payment.types";

const PaymentOverviewAccordion = ({ heading, summary, bg }: PaymentOverviewAccordionProps) => {
  const [expanded, setExpanded] = useState(true);

  const handleAccordionChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  return (
    <Accordion
      defaultExpanded
      expanded={expanded}
      onChange={handleAccordionChange}
      component="section"
      sx={{
        boxShadow: "none",
        borderRadius: "12px !important",
        border: "1px solid #EAECF0",
        backgroundImage: bg && expanded ? `url(${bg})` : "none",
        backgroundPosition: bg && expanded ? "right" : "initial",
        backgroundRepeat: bg && expanded ? "no-repeat" : "initial",
        backgroundSize: bg && expanded ? "contain" : "initial",
        "&:before": {
          bgcolor: "unset",
        },
      }}
    >
      <AccordionSummary expandIcon={<PaymentAccordionArrowIcon />}>
        <Typography
          component="span"
          sx={{
            color: "#1C1C1C",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
          }}
        >
          {heading}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {summary}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default PaymentOverviewAccordion;
